export default "__VITE_ASSET__Cd2F51B2__"